// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import { CreditCardBillingAddressDto } from "@insite/client-framework/Types/ApiModels";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { reviewSectionAddressesStyles } from "@keller/Overrides/Widgets/CheckoutShipping/SharedAddresses.style";
import React from "react";

interface OwnProps {
    creditCardBillInformation: CreditCardBillingAddressDto;
    extendedStyles?: CreditCardAddressInfoDisplayStyles;
}
export interface CreditCardAddressInfoDisplayStyles {
    container?: GridContainerProps;
    headingGridItem?: GridItemProps;
    heading?: TypographyPresentationProps;
    editLink?: LinkPresentationProps;
    addressGridItem?: GridItemProps;
    address?: AddressInfoDisplayStyles;
}
export const creditCardAddressInfoDisplayStyles: CreditCardAddressInfoDisplayStyles = {
    container: { ...reviewSectionAddressesStyles.container },
    headingGridItem: { ...reviewSectionAddressesStyles.headingGridItem },
    heading: {...reviewSectionAddressesStyles.heading},
    addressGridItem: { ...reviewSectionAddressesStyles.headingGridItem }};
const CreditCardAddressInfoDisplay = ({ creditCardBillInformation, extendedStyles }: OwnProps) => {
    const styles = mergeToNew(creditCardAddressInfoDisplayStyles, extendedStyles);
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.headingGridItem}>
                <Typography {...styles.heading}>{translate("Credit Card Address")}</Typography>
            </GridItem>
            <GridItem {...styles.addressGridItem}>
                <AddressInfoDisplay
                    address1={creditCardBillInformation.address1}
                    address2={creditCardBillInformation.address2}
                    city={creditCardBillInformation.city}
                    postalCode={creditCardBillInformation.postalCode}
                    state={creditCardBillInformation.stateAbbreviation}
                    extendedStyles={styles.address}     />
            </GridItem>
        </GridContainer>
    );
};
export default CreditCardAddressInfoDisplay;